import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Loader from '../../components/Loader/Loader';
import moment from 'moment';
import axios from 'axios';
import { toast } from 'react-toastify';

const Students = () => {
  const { id } = useParams();
  const [loader, setLoader] = useState(true); 
  const [isModelLoading, setIsModelLoading] = useState(false);
  const [isSlipModalOpen, setIsSlipModalOpen] = useState(false);
  const [singleData, setSingleData] = useState({});
  const [students, setStudents] = useState([]);
const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  useEffect(() => {
    fetchAllStudentInCourse(id);
  }, [id]);

  const fetchAllStudentInCourse = (courseId) => {
    setLoader(true);
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };
  
    fetch(
      `https://quran-backend-theta.vercel.app/v1/user/all-students-course/${courseId}?page=${currentPage}&limit=6`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        
        if (result?.data && Array.isArray(result.data)) {
          setStudents(result.data);
          // Add this line to set total pages from the API response
          setTotalPages(result.totalPages || Math.ceil(result.totalStudents / 6) || 1);
        } else {
          setStudents([]);
          setTotalPages(1);
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error('Failed to fetch students');
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const handleChangeStatus = async (newStatus, studentId) => {
    setStudents((prevStudents) =>
      prevStudents.map((student) =>
        student._id === studentId ? { ...student, isLoading: true } : student
      )
    );

    try {
      const res = await axios.patch(
        `https://quran-backend-theta.vercel.app/v1/admin/update-enrollment-status/${studentId}`,
        {
          newStatus: newStatus
        }
      );

      console.log('GAME OF THRONE', res.data);

      if (res.data.success) {
        setStudents((prevStudents) =>
          prevStudents.map((student) =>
            student._id === studentId
              ? { ...student, status: newStatus, isLoading: false }
              : student
          )
        );
      } else {
        console.error(res.data.message);
      }
    } catch (error) {
      console.error('Error updating status:', error);
    } finally {
      setStudents((prevStudents) =>
        prevStudents.map((student) =>
          student._id === studentId ? { ...student, isLoading: false } : student
        )
      );
    }
  };

  const ApproveFee = (link) => {
    setIsModelLoading(true);

    const requestOptions = {
      method: 'PATCH',
      redirect: 'follow'
    };

    fetch(
      `https://quran-backend-theta.vercel.app/v1/admin/fee-mark-paid/${link?._id}`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        if (data?.success === false) {
          toast.error(data?.error);
          setIsModelLoading(false);
        }
        setIsModelLoading(false);
        toast.success('Fee is Paid');
        window.location.reload();
      })
      .catch((error) => {
        toast.error(error);
        setIsModelLoading(false);
      });
  };

  const closeModal = () => {
    setIsSlipModalOpen(!isSlipModalOpen);
  };


  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  return (
    <section className="mb-20 mt-7">
      <div className="rounded-lg overflow-x-auto">
        {loader ? ( // Show loader while fetching data
          <Loader />
        ) : students.length > 0 ? ( // Render student list if data is available
          <div className="flex flex-col">
            <div className="sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full sm:px-6 lg:px-8">
                <div className="overflow-hidden">
                  <table className="min-w-full mb-0">
                    <thead>
                      <tr className="rounded-lg whitespace-nowrap">
                        <th className="text-sm text-primary font-bold px-6 py-4">Sr No.</th>
                        <th className="text-sm text-primary font-bold px-6 py-4">ID</th>
                        <th className="text-sm text-primary font-bold px-6 py-4">Name</th>
                        <th className="text-sm text-primary font-bold px-6 py-4">Father Name</th>
                        <th className="text-sm text-primary font-bold px-6 py-4">Phone no</th>
                        <th className="text-sm text-primary font-bold px-6 py-4">Country</th>
                        <th className="text-sm text-primary font-bold px-6 py-4">Teacher</th>
                        <th className="text-sm text-primary font-bold px-6 py-4">Timing</th>
                        <th className="text-sm text-primary font-bold px-6 py-4">Payment</th>
                        <th className="text-sm text-primary font-bold px-6 py-4">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {students.map((student, index) => (
                        <tr
                          key={student?._id}
                          style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
                          className="bg-white border-b-8 border-white rounded-md"
                        >
                           <td className="align-middle bg-white text-sm font-normal px-6 py-3 whitespace-nowrap text-center">
                            <span className="bg-white text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline bg-green-200 rounded-full">
                              {`${index+1}`}
                            </span>
                          </td>
                          {/* ID */}
                          <td className="align-middle bg-white text-sm font-normal px-6 py-3 whitespace-nowrap text-center">
                            <span className="bg-white text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline bg-green-200 rounded-full">
                              {student?.student?.studentId}
                            </span>
                          </td>

                          {/* Name */}
                          <td className="text-sm bg-white font-normal text-center px-6 py-4 whitespace-nowrap">
                            <Link
                              to={`/student-details/${student?.course}/${student?.email}`}
                              className="text-base text-secondary py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline bg-green-200 rounded-full"
                            >
                              {student?.studentName}
                            </Link>
                          </td>

                          {/* Father Name */}
                          <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                            <span className="text-base text-black py-1 px-2.5 leading-none whitespace-nowrap bg-green-200 rounded-full">
                              {student?.fatherName}
                            </span>
                          </td>

                          {/* Phone Number */}
                          <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                            <span className="text-base text-black py-1 px-2.5 leading-none whitespace-nowrap bg-green-200 rounded-full">
                              {student?.number}
                            </span>
                          </td>

                          {/* Country */}
                          <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                            <span className="text-base text-black py-1 px-2.5 leading-none whitespace-nowrap bg-green-200 rounded-full">
                              {student?.country}
                            </span>
                          </td>

                          {/* Teacher */}
                          <td className="align-middle bg-white font-normal px-6 py-4 whitespace-nowrap">
                            <span className="text-base text-black py-1 px-2.5 leading-none whitespace-nowrap bg-green-200 rounded-full">
                              {student?.teacher?.name}
                            </span>
                          </td>

                          {/* Timing */}
                          <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                            <span className="text-base text-black py-1 px-2.5 leading-none whitespace-nowrap bg-green-200 rounded-full">
                              {student?.assignmentDetails?.timeSlots?.map((item, index) => (
                                <div key={index}>
                                  {item?.startTime} - {item?.endTime}
                                </div>
                              ))}
                            </span>
                          </td>

                          {/* Payment */}
                          {/* <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                            {student?.feeStatus?.status === '-' ? (
                              // Case 1: Fee status is "-".
                              <span className="text-base text-secondary py-1 px-2.5 leading-none whitespace-nowrap">
                                {student?.nextPaymentDate
                                  ? moment(student?.nextPaymentDate).format('MMM Do YY')
                                  : 'N/A'}
                              </span>
                            ) : student?.feeStatus?.status === 'paid' ? (
                              // Case 2: Fee status is "paid".
                              (() => {
                                const slipPayDate = moment(student?.feeStatus?.slipPayDate);
                                const nextPaymentDate = moment(student?.nextPaymentDate);
                                const diffDays = nextPaymentDate.diff(slipPayDate, 'days');

                                return (
                                  <span
                                    style={{
                                      color: diffDays > 30 ? 'red' : 'inherit',
                                    }}
                                    className="text-base"
                                  >
                                    {moment(student?.nextPaymentDate).format('MMM Do YY')}
                                  </span>
                                );
                              })()
                            ) : (
                              // Case 3: Other statuses, show Approve Fee Slip link.
                              <a
                                onClick={() => {
                                  setIsSlipModalOpen(true);
                                  setSingleData(student);
                                }}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-base text-[#FF7E00] cursor-pointer"
                              >
                                Approve Fee Slip
                              </a>
                            )}
                          </td> */}
                          <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                            {student?.feeStatus?.status === '-' ? (
                              // Case 1: Fee status is "-".
                              <span
                                className="text-base text-secondary py-1 px-2.5 leading-none whitespace-nowrap"
                                style={{
                                  color: moment().isAfter(moment(student?.nextPaymentDate))
                                    ? 'red'
                                    : 'text-secondary'
                                }}
                              >
                                {student?.nextPaymentDate
                                  ? moment(student?.nextPaymentDate).format('MMM Do YY')
                                  : 'N/A'}
                              </span>
                            ) : student?.feeStatus?.status === 'paid' ? (
                              // Case 2: Fee status is "paid".
                              (() => {
                                const slipPayDate = moment(student?.feeStatus?.slipPayDate);
                                const nextPaymentDate = moment(student?.nextPaymentDate);
                                const diffDays = nextPaymentDate.diff(slipPayDate, 'days');

                                return (
                                  <span
                                    style={{
                                      color:
                                        diffDays > 30 || moment().isAfter(nextPaymentDate)
                                          ? 'red'
                                          : 'inherit'
                                    }}
                                    className="text-base"
                                  >
                                    {moment(student?.nextPaymentDate).format('MMM Do YY')}
                                  </span>
                                );
                              })()
                            ) : (
                              // Case 3: Other statuses, show Approve Fee Slip link.
                              <a
                                onClick={() => {
                                  setIsSlipModalOpen(true);
                                  setSingleData(student);
                                }}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-base text-[#FF7E00] cursor-pointer"
                              >
                                Approve Fee Slip
                              </a>
                            )}
                          </td>
                          {/* Status */}
                          <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                            {/* {student?.isLoading ? (
                              <span className="ml-2 text-gray-500">Loading...</span>
                            ) : (
                              <select
                                className={`px-3 py-2 rounded-md ${student?.status === 'approved'
                                  ? 'bg-[#DFF7E3] text-[#23A118]'
                                  : 'bg-[#FCE8E6] text-[red]'
                                  }`}
                                value={student?.status}
                                onChange={(e) => handleChangeStatus(e.target.value, student?._id)}
                              >
                                <option value="pending">Pending</option>
                                <option value="approved">Approved</option>
                                <option value="inactive">Inactive</option>
                                <option value="completed">Complete</option>
                              </select>
                            )} */}

                            <span
                              className={`text-base py-1 px-2.5 leading-none whitespace-nowrap rounded-md ${
                                student.status === 'pending'
                                  ? 'bg-[#DFF7E3] text-[#23A118]'
                                  : student.status === 'completed'
                                    ? 'bg-[#FFE4E4] text-[#FF0000]'
                                    : student.status === 'approved'
                                      ? 'bg-[#FFF3E0] text-[#FFA500]'
                                      : student.status === 'inactive'
                                        ? 'bg-[#E0F7FA] text-[#00BCD4]'
                                        : 'bg-gray-200 text-black'
                              }`}
                            >
                              {student.status}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
               

              </div>
              
            </div>

            
          </div>
        ) : (
          
          <div className="text-center py-10">
            <p className="text-gray-500">No students found for this course.</p>
          </div>
        )}

        
      </div>
      <div className="flex justify-end mt-4 items-center">
  <button
    onClick={() => handlePageChange(currentPage - 1)}
    disabled={currentPage === 1}
    className="px-4 py-2 bg-gray-200 text-gray-700 cursor-pointer rounded hover:bg-gray-300"
  >
    Previous
  </button>
  
  <span className="mx-4 py-2">
    Page {currentPage} of {totalPages}
  </span>
  
  <select
    value={currentPage}
    onChange={(e) => handlePageChange(Number(e.target.value))}
    className="mx-2 px-3 py-2 border rounded bg-white"
  >
    {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
      <option key={page} value={page}>
        {page}
      </option>
    ))}
  </select>
  
  <button
    onClick={() => handlePageChange(currentPage + 1)}
    disabled={currentPage === totalPages}
    className="px-4 py-2 bg-gray-200 text-gray-700 cursor-pointer rounded hover:bg-gray-300"
  >
    Next
  </button>
</div>
      
      {isSlipModalOpen && (
        <>
          {console.log('GAMe', singleData)}
          <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
            onClick={closeModal}
          >
            <div
              className="bg-white p-6 rounded overflow-y-auto h-[60vh] shadow-lg max-w-xl w-full relative"
              onClick={(e) => e.stopPropagation()} // Prevent closing modal when clicking inside
            >
              {/* X Icon for closing */}
              <button
                onClick={closeModal}
                className="absolute top-2 right-2 text-gray-500 hover:text-red-500"
              >
                ✕
              </button>

              <h2 className="text-lg font-bold mb-4">Fee Slip</h2>

              <div className="w-full mb-6">
                <img
                  src={singleData?.feeStatus?.slipUrl}
                  alt="Fee Slip"
                  className="w-full h-auto rounded mb-4"
                />
              </div>

              <div className="flex justify-end gap-4">
                {/* Cancel Button */}
                <button
                  onClick={closeModal}
                  className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
                >
                  Cancel
                </button>

                {/* Approve Button */}
                <button
                  onClick={() => ApproveFee(singleData)}
                  className="px-4 py-2 bg-[#FF7E00] text-white rounded"
                  disabled={isModelLoading} // Disable button during loading
                >
                  {isModelLoading ? (
                    <div className="spinner-border animate-spin w-5 h-5 border-t-2 border-white rounded-full" />
                  ) : (
                    'Approve'
                  )}
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </section>
  );
};

export default Students;
